import { render, staticRenderFns } from "./TefConfig.vue?vue&type=template&id=d531d2aa"
import script from "./TefConfig.vue?vue&type=script&lang=js"
export * from "./TefConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports